import { nanoid } from 'nanoid';
import css from '../components/questions/Questions.module.css';

const questionsData = [
  {
    id: nanoid(),
    question: 'Как зарегистрироваться в Личном кабинете и пользоваться им.',
    answer: (
      <>
        При регистрации указываете номер телефона, пароль и ставите галочку о
        согласии с обработкой
        <br /> персональных данных. Далее придет код подтверждения в WhatsApp,
        который необходимо ввести.
        <br /> В Личном кабинете в разделе «Профиль» можно выбрать приоритетный
        клуб.
        <br /> В разделе «Главная» находятся все приобретенные услуги.
        <br /> В «Занятия» указана история посещений.
        <br /> Раздел «Расписание» имеет функционал приобретения и записи
        клиентов.
        <br /> Также услуги можно приобрести в разделе «Магазин», но без наличия
        записи.
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Какие типы услуг есть',
    answer: (
      <>
        В Культурном центре «Строгино» существует групповые и индивидуальные
        занятия.
        <p className={css.answerListText}>Список услуг групповых занятий:</p>
        <ul className={css.answerList}>
          <li className={css.answerItem}>
            <span>Пробное занятия.</span> Включает в себя одноразовое платное
            или
            <br /> бесплатное посещение без возможности дальнейшего
            использования.
          </li>
          <li className={css.answerItem}>
            <span>Разовые занятия.</span> Включают в себя одноразовое платное
            посещение на
            <br /> определенную дату.
          </li>
          <li className={css.answerItem}>
            <span>Абонемент.</span> Включает в себя ограниченное количество
            занятий на
            <br /> протяжении 40 дней с момента первого посещения.
          </li>

          <li className={css.answerItem}>
            <span>Мастер классы.</span> Включают в себя одноразовое посещение на
            <br /> определенную дату.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Как записаться на пробное занятие',
    answer: (
      <>
        Записаться на пробное занятие можно через раздел «Расписание», либо в
        «Магазине»,
        <br /> выбрав необходимую услугу с пробным занятием.
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Как приобрести услугу',
    answer: (
      <>
        Услугу приобрести могут только авторизованные клиенты через «Расписание»
        или
        <br /> «Магазин». Также можно воспользоваться «Быстрой покупкой» на
        страницах каждой
        <br /> студии переходя по ссылкам в «Тарифах».
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Какие способы оплаты',
    answer: (
      <>
        Оплатить услуги можно через сайт, мобильное приложение или
        <br /> на месте в отделе продаж Культурных центров «Строгино».
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Как пользоваться магазином',
    answer: (
      <>
        В магазине можно приобрести услуги по прайсу Культурного центра
        «Строгино». Чтобы
        <br /> приобрести услуги через магазин, необходимо в Личном кабинете
        перейти в данный
        <br /> раздел и выбрать необходимую услугу из расположенных в каталогах.
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Как пользоваться расписанием',
    answer: (
      <>
        <span className={css.textSpan}>
          В разделе «Расписание» можно отсортировать занятиям:
        </span>
        <ul className={css.answerListLast}>
          <li className={css.answerItemLast}>по клубам Культурного центра;</li>
          <li className={css.answerItemLast}>по времени суток;</li>
          <li className={css.answerItemLast}>по занятиям;</li>
          <li className={css.answerItemLast}> по педагогу;</li>
          <li className={css.answerItemLast}> по группам (каталогам).</li>
        </ul>
        <p className={css.answerText}>
          Отобразить список занятий также можно на неделю, или на определенный
          день. Расположено в правом
          <br /> верхнем углу расписания.
          <br /> Выбирая необходимое занятие, попадаете в раздел предварительной
          покупки и записи. Здесь Вы можете
          <br /> ознакомится с информацией о преподавателе, о самом занятии и
          сколько свободных мест осталось.
          <br /> Нажимая кнопку «Купить», попадаете на предварительную покупку
          пакета услуг по данному занятию.
          <br /> Далее выбираете нужную услугу на приобретение.
        </p>
        <p className={css.answerText}>
          <br />
          <span className={css.answerTextLastSpan}>Возможные ошибки:</span>
          <br /> «В данный промежуток времени вы уже записаны». Это означает,
          что у вас есть предварительная запись на
          <br /> другие услуги в данном промежутке времени. Чтобы увидеть,
          необходимо обновить страницу и на них будет
          <br /> синий «флажок». Предварительная запись пропадает в течении 5
          минут.
        </p>
      </>
    ),
  },
  {
    id: nanoid(),
    question: 'Как составить расписание и записаться на занятия',
    answer: (
      <>
        Если у вас уже есть купленный абонемент, то Вы автоматически
        записываетесь на все занятия. К Вам придет
        <br /> сообщение по WhatsApp. Отредактировать его можно через Личный
        кабинет (в разделе «Занятия» и/или
        <br /> приложение клиента («Мои занятия») и нажимаете «Отменить запись».
        <br />
        Чтобы записаться на занятия у Вас должна быть оплачена услуга. Если у
        клиента имеется задолженность, то
        <br /> найти информацию можно в Личном кабинете, раздел «Главное». Для
        записи на занятия перейдите в раздел
        <br /> «Расписание». Вместо «Купить» будет указано «Бронирование» и
        приобретенная услуга.
        <br /> Для бюджетных групп создана функция отправки заявок. Если
        бюджетная группа открыта, то на странице
        <br /> сайта группы Вы можете оставить заявку на запись в бюджетную
        группу. После одобрения с Вами свяжутся
        <br /> сотрудники Культурного центра «Строгино» для подписания договора.
      </>
    ),
  },
];

export { questionsData };
